<template>
  <div>
    <el-form-item :label="label" :prop="prop" :rules="rules">
      <el-upload
        action="https://dingo-mighty-mosquito.ngrok-free.app/file/upload"
        list-type="picture-card"
        :file-list="fileList"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        :on-exceed="handleExceed"
        :limit="limit"
        :auto-upload="false"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
    <!-- 预览图片的弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClosePreview"
      title="图片预览"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <img :src="previewImage" class="preview-image" alt="预览图片" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 当前预览的图片地址
      previewImage: "",
      imgSrc: "", //zhan
    };
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    prop: {
      type: String,
      required: true,
    },
    fileList: {
      type: Array,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
    rules: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      default: 2,
    },
  },
  methods: {
    // 上传前的检查，确保每次只上传一张图片
    handleExceed() {
      if (this.fileList.length >= this.limit) {
        return this.$message.warning(`最多上传${this.limit}张图片`);
      }
    },
    beforeUpload(file) {
      if (this.fileList.length >= this.limit) {
        this.$message.warning("只能上传一张图片");
        return false; // 阻止上传
      }
      return true; // 允许上传
    },
    // 关闭预览弹窗
    handleClosePreview(done) {
      this.dialogVisible = false;
      done();
    },
    // 预览文件
    handlePreview(file) {
      // 点击图片时，设置预览图片地址并显示弹窗
      this.previewImage = file.url || URL.createObjectURL(file.raw);
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.onRemove(file, fileList);
    },
    handleChange(file, fileList) {
      this.imgSrc = file.url;
      this.onChange(file, fileList);
    },
  },
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #409eff;
}
.preview-image {
  width: 100%;
  height: auto;
}
</style>
